import React, { useRef } from "react";
import { View, Text, ScrollView, StyleSheet, Platform, Dimensions } from "react-native";	
import HeaderBar, { useScrollHide } from '../../Widgets/HeaderBar';
import { HEADER_PADDING } from '../../constants';

const { width } = Dimensions.get('window');
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
const isSmallDesktop = width >= 1024 && width <= 1440;	

const Privacy = () => {
	// Firebase Storage URL for PDF
	const FIREBASE_STORAGE_BASE = "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o";
	const pdfFileUrl = `${FIREBASE_STORAGE_BASE}/pdfs%2FPrivacy%20Agreement.pdf?alt=media`;

	const { headerTranslateY, onScroll } = useScrollHide('scrollView');
	const scrollViewRef = useRef();

	return (
		<View style={styles.body}>
			<HeaderBar headerTranslateY={headerTranslateY} />
			<ScrollView ref={scrollViewRef} style={styles.pdfContainer} onScroll={onScroll} scrollEventThrottle={16} contentContainerStyle={{ paddingTop: isMobile ? HEADER_PADDING.mobile : isTablet ? HEADER_PADDING.tablet : HEADER_PADDING.desktop, paddingBottom: 200 }}>
				<View style={styles.pdfWrapper}>
					{Platform.OS === "web" ? (
						<iframe 
							src={pdfFileUrl} 
							style={styles.pdf} 
							frameBorder="0"
						>
							Your browser does not support iframes.
						</iframe>
					) : (
						<Text style={styles.text}>PDF display is not supported on this platform.</Text>
					)}
				</View>
			</ScrollView>
		</View>
	);
};

// Styles
const styles = StyleSheet.create({
	body: {
		flex: 1,
		alignItems: "center",
		backgroundColor: "#4c956c",
		height: "100vh"
	},
	pdfContainer: {
		flex: 1,
		width: "90vw",
		borderWidth: 1,
		borderColor: "#fff",
		borderRadius: 8,
		overflow: "hidden",
	},
	pdfWrapper: {
		paddingTop: 20,
	},
	pdf: {
		width: "100%",
		height: "100vh",
		minHeight: 500,
	},
	text: {
		fontFamily: "Bodoni72Smallcaps",
		textAlign: "center",
		margin: 20,
	}
});

export default Privacy;
